import { createContext, useState } from 'react'

/* eslint-disable react-refresh/only-export-components -- context module */

export type BreadCrumbsContextDefaultTypes = {
    breadcrumbs: { name: string; id: string }[]
    setBreadcrumbs: (arg: { name: string; id: string }[]) => void
}

const defaultValues: BreadCrumbsContextDefaultTypes = {
    breadcrumbs: [],
    setBreadcrumbs: () => undefined,
}

export const BreadCrumbsContext = createContext(defaultValues)

export function BreadCrumbsContextProvider({ children }: { children: React.ReactNode }) {
    const [breadcrumbs, setBreadcrumbs] = useState<{ name: string; id: string }[]>([])

    return (
        <BreadCrumbsContext.Provider
            value={{
                breadcrumbs,
                setBreadcrumbs,
            }}
        >
            {children}
        </BreadCrumbsContext.Provider>
    )
}
